import { ReactNode } from 'react';
import { useToastStore } from '../lib/store';

// 이 함수는 어디서든 import 해서 호출할 수 있음
export function showToast(
    message: ReactNode,
    duration = 2000,
    type: 'save' | 'error' = 'save',
    custom = false
) {
    // zustand store의 현재 상태(또는 actions)에 접근
    const { showToast, open } = useToastStore.getState();
    if (!open) showToast(message, duration, type, custom);
}

export function hideToast() {
    const { hideToast } = useToastStore.getState();
    hideToast();
}
